import SearchBarProvider from './hooks/useSearchBar';

import { SearchBarProps } from './@types/SearchBarProps';
import SearchBarContainer from './handles/SearchBarContainer';
import SearchBarInnerContainer from './handles/SearchBarInnerContainer';
import AutoCompleteOuterContainer from './handles/AutoCompleteOuterContainer';

import './SearchBar.scss';

const SearchBar = (props: SearchBarProps) => (
	<SearchBarProvider {...props}>
		<SearchBarContainer>
			<SearchBarInnerContainer>
				<AutoCompleteOuterContainer />
			</SearchBarInnerContainer>
		</SearchBarContainer>
	</SearchBarProvider>
);

export default SearchBar;
